/** @jsxImportSource @emotion/react */
import Modal from 'react-bootstrap-modal';
import t from '@rcm/i18n-client';

const InfoModal = ({ openModal, setOpenModal, modalText, customClick = null }) => {
  const toggleModal = () => {
    setOpenModal(!openModal);
    customClick();
  };

  return (
    <Modal
      noBackdrop={true}
      show={openModal}
      head={
        <div>
          <h3>{t(modalText)}</h3>
        </div>
      }
      foot={
        <div>
          <button className="btn btn-primary" onClick={toggleModal}>
            OK, Thanks
          </button>
        </div>
      }
    />
  );
};

export default InfoModal;
